<template>
    <div class="filters">
        <button
            v-for="filter in filters"
            :key="filter.value"
            :class="{'isActive': active === filter.value}"
            class="filter smallTitle"
            type="button"
            @click="changeFilter(filter.value)"
        >
            {{ filter.label }}
        </button>
    </div>
</template>

<script>
export default {
    props: {
        filters: {
            type: Array,
            required: true,
        },
        active: {
            type: String,
            required: true,
        },
    },
    methods: {
        changeFilter(filter) {
            if (this.active === filter) return;

            this.$emit('changed', filter);
        },
    },
};
</script>

<style lang="postcss" scoped>
.filters {
    margin-bottom: -8px;
}
.filter {
    padding: 10px 16px;
    border-radius: var(--borderRadius);
    color: var(--grey600);
    margin-right: 8px;
    margin-bottom: 8px;
}
.isActive {
    background-color: var(--primary);
    color: #fff;
}
</style>
